import React, { useContext, useEffect, useState } from 'react';
import { Col, Menu, Row } from 'antd';
import { NavLink, Route, Switch, useLocation } from 'react-router-dom';
import { UsersPage } from './users';
import { RolePage, RolesPage } from './roles';
import {
  SafetyOutlined,
  ToolOutlined,
  UserOutlined,
  NotificationOutlined,
  IssuesCloseOutlined,
  FieldBinaryOutlined,
  HighlightOutlined,
  GlobalOutlined,
  CheckCircleOutlined,
  DollarCircleOutlined,
  LineChartOutlined,
  EnvironmentOutlined,
  ShopOutlined,
  ClusterOutlined,
} from '@ant-design/icons';
import { UserContext } from '../contexts';
import {
  hasAdminRolesPageRole,
  hasAdminUsersPageRole,
  hasAdminSystemSettingsPageRole,
  hasAdminNotificationPageRole,
  hasAdminErrorStatusPageRole,
  hasAdminErrorCodesPageRole,
  hasAdminErrorFindersPageRole,
  hasAdminCountriesPageRole,
  hasAdminFourMsPageRole,
  hasAdminCostsPageRole,
  hasAdminFrequenciesPageRole,
  hasAdminCustomerClassesPageRole,
  hasAdminEquipmentsPageRole,
  hasAdminProductionSitesPageRole,
  hasAdminSuppliersPageRole,
} from '../../utils';
import { SystemSettingsPage } from './system-settings';
import { NotificationTypesPage } from './notification-types/index';
import { ErrorCodesPage } from './error-codes/index';
import { ErrorFindersPage } from './error-finders/index';
import { ErrorStatusesPage } from './error-statuses/index';
import { CountriesMenuPage } from './countries-cities/index';
import { FourMsPage } from './four-ms/index';
import { CostsPage } from './costs/index';
import { FrequenciesPage } from './frequencies/index';
import { CustomerClassesPage } from './customer-classes/index';
import { EquipmentsPage } from './equipments/index';
import { ProductionSitesMenuPage } from './production-sites/index';
import { SuppliersPage } from './suppliers/index';

export function AdminPage() {
  const { pathname } = useLocation();
  const [path, setPath] = useState('');
  const { user } = useContext(UserContext);

  useEffect(() => {
    let path = '/admin';
    if (pathname === path) {
      path += '/users';
    } else {
      path += '/' + pathname.split('/')[2];
    }
    setPath(path);
  }, [pathname]);

  const links = [];
  if (hasAdminUsersPageRole(user)) {
    links.push({
      path: '/admin/users',
      text: 'Kullanıcılar',
      icon: <UserOutlined />,
    });
  }
  if (hasAdminRolesPageRole(user)) {
    links.push({
      path: '/admin/roles',
      text: 'Roller',
      icon: <SafetyOutlined />,
    });
  }
  if (hasAdminNotificationPageRole(user)) {
    links.push({
      path: '/admin/notification-types',
      text: 'Bildirim türleri',
      icon: <NotificationOutlined />,
    });
  }
  if (hasAdminErrorStatusPageRole(user)) {
    links.push({
      path: '/admin/error-statuses',
      text: 'Hata statüleri',
      icon: <IssuesCloseOutlined />,
    });
  }
  if (hasAdminErrorCodesPageRole(user)) {
    links.push({
      path: '/admin/error-codes',
      text: 'Hata kodları',
      icon: <FieldBinaryOutlined />,
    });
  }
  if (hasAdminErrorFindersPageRole(user)) {
    links.push({
      path: '/admin/error-finders',
      text: 'Hata tespit edenler',
      icon: <HighlightOutlined />,
    });
  }
  if (hasAdminCountriesPageRole(user)) {
    links.push({
      path: '/admin/countries',
      text: 'Ülke ve şehirler',
      icon: <GlobalOutlined />,
    });
  }
  if (hasAdminFourMsPageRole(user)) {
    links.push({
      path: '/admin/four-ms',
      text: '4M’ler',
      icon: <CheckCircleOutlined />,
    });
  }
  if (hasAdminCostsPageRole(user)) {
    links.push({
      path: '/admin/costs',
      text: 'Maliyetler',
      icon: <DollarCircleOutlined />,
    });
  }
  if (hasAdminFrequenciesPageRole(user)) {
    links.push({
      path: '/admin/frequencies',
      text: 'Frekanslar',
      icon: <LineChartOutlined />,
    });
  }
  if (hasAdminCustomerClassesPageRole(user)) {
    links.push({
      path: '/admin/customer-classes',
      text: 'Müşteri sınıfları',
      icon: <ClusterOutlined />,
    });
  }
  if (hasAdminEquipmentsPageRole(user)) {
    links.push({
      path: '/admin/equipments',
      text: 'Malzemeler',
      icon: <ToolOutlined />,
    });
  }
  if (hasAdminProductionSitesPageRole(user)) {
    links.push({
      path: '/admin/production-sites',
      text: 'Üretim yerleri',
      icon: <EnvironmentOutlined />,
    });
  }
  if (hasAdminSuppliersPageRole(user)) {
    links.push({
      path: '/admin/suppliers',
      text: 'Tedarikçiler',
      icon: <ShopOutlined />,
    });
  }

  // if (hasAdminSystemSettingsPageRole(user)) {
  //   links.push({
  //     path: '/admin/system-settings',
  //     text: 'Sistem ayarları',
  //     icon: <ToolOutlined />,
  //     component: SystemSettingsPage,
  //   });
  // }

  return (
    <Row>
      <Col span={6} xs={24} sm={24} md={6} lg={6} xl={5} xxl={4}>
        <Menu mode="inline" selectedKeys={[path]} style={{ paddingBottom: '3rem' }}>
          <Menu.ItemGroup title="Yönetim">
            {links.map(l => (
              <Menu.Item key={l.path} icon={l.icon}>
                <NavLink to={l.path}>{l.text}</NavLink>
              </Menu.Item>
            ))}
          </Menu.ItemGroup>
        </Menu>
      </Col>
      <Col span={18} xs={24} sm={24} md={18} lg={18} xl={19} xxl={20}>
        <Switch>
          <Route exact path="/admin" component={UsersPage} />
          <Route exact path="/admin/users" component={UsersPage} />
          <Route exact path="/admin/roles" component={RolesPage} />
          <Route exact path="/admin/roles/:id" component={RolePage} />
          <Route exact path="/admin/system-settings" component={SystemSettingsPage} />
          <Route exact path="/admin/notification-types" component={NotificationTypesPage} />
          <Route exact path="/admin/error-statuses" component={ErrorStatusesPage} />
          <Route exact path="/admin/error-codes" component={ErrorCodesPage} />
          <Route exact path="/admin/error-finders" component={ErrorFindersPage} />
          <Route exact path="/admin/countries" component={CountriesMenuPage} />
          <Route exact path="/admin/four-ms" component={FourMsPage} />
          <Route exact path="/admin/costs" component={CostsPage} />
          <Route exact path="/admin/frequencies" component={FrequenciesPage} />
          <Route exact path="/admin/customer-classes" component={CustomerClassesPage} />
          <Route exact path="/admin/equipments" component={EquipmentsPage} />
          <Route exact path="/admin/production-sites" component={ProductionSitesMenuPage} />
          <Route exact path="/admin/suppliers" component={SuppliersPage} />
        </Switch>
      </Col>
    </Row>
  );
}
